module.exports = __webpack_public_path__ + "VIPH22.png?a545063b8870a6cc86374da0765cb706";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH22.png
// module id = 95
// module chunks = 0